const Link = {
  MuiLink: {
    styleOverrides: {
      root: {
        textDecorationColor: "transparent"
      }
    }
  }
}
export default Link